/* eslint-disable */

import _includes from 'lodash/includes';
import EVENTS from '@/utils/Constants/Events';
import CONST from '@/utils/Constants/General';
import { GET_BASE } from '@/api';

const URL_FACETS = 'search/facets';
const URL_RESULTS = 'search/results';

export const paginationResults = async ({
  nextPage,
  searchType,
  hasLoadMore,
  query,
  sort,
  successCB,
  failCB,
}) => {
  try {
    const { data } = await GET_BASE(
      `${URL_RESULTS}?searchType=${searchType}&q=${query}&page=${nextPage}&hasLoadMore=${hasLoadMore}${
        sort ? `&sort=${sort}` : ''
      }`,
    );
    return (typeof successCB === 'function' && successCB(data)) || data;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};

export default async ({
  searchType,
  searchTerm,
  query,
  sort,
  hasLoadMore,
  config,
  successCB,
  failCB,
}) => {
  try {
    let filters;
    const currSearch = searchTerm || query;
    const needsFacet = _includes(
      [CONST.SEARCH.TYPE.PRODUCT, CONST.SEARCH.TYPE.RECIPE],
      searchType,
    );
    if (needsFacet) {
      const { data } = await GET_BASE(
        `${URL_FACETS}?searchType=${searchType}&q=${currSearch}${
          sort ? `&sort=${sort}` : ''
        }`,
        config,
      );
      filters = data;
    }
    const { data: html } = await GET_BASE(
      `${URL_RESULTS}?searchType=${searchType}&q=${currSearch}&hasLoadMore=${hasLoadMore}${
        sort ? `&sort=${sort}` : ''
      }`,
      config,
    );
    DLG.EVE.emit(EVENTS.SEARCH.RESULTS.FIRSTLOAD);
    return (
      (typeof successCB === 'function' && successCB({ filters, html })) || {
        filters,
        html,
      }
    );
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
